module.exports = __webpack_public_path__ + "media/images/icons/filled/bank-15fdf684b40e94ca012cea7b31e216dd.svg";